export default [
  {
    path: 'operations',
    name: 'operations',
    component: () => import('@/views/operations/Wrapper'),
    children: [
      {
        path: '/operations/maintenance/dashboard/:type?',
        name: 'dashboardMaintenance',
        component: () => import('@/views/operations/maintenance/Main'),
      },
      {
        path: 'message',
        name: 'message',
        component: () => import('@/views/operations/MessageSearchWrapper.vue'),
      },
      {
        path: 'message-management/:isEditMode?/:id?',
        name: 'message-management',
        component: () =>
          import('@/views/operations/message/MessageManagementWrapper.vue'),
      },
      {
        path: '/operations/calendar',
        name: 'calendarMain',
        component: () => import('@/views/operations/MainEventWrapper.vue'),
      },
      {
        path: '/operations/calendar/event-management/:id?',
        name: 'calendarEventManagement',
        component: () =>
          import('@/views/operations/EventManagementWrapper.vue'),
      },
      {
        path: '/operations/workshop',
        name: 'workshop',
        component: () => import('@/views/operations/workshop/Wrapper'),
        children: [
          {
            path: '',
            name: 'workshop',
            component: () => import('@/views/operations/workshop/Main'),
          },
        ],
      },
    ],
  },
];
